const NETWORK_ERROR_PATTERNS = [
  'failed to fetch',
  'network request failed',
  'networkerror',
  'load failed',
  'timeout',
  'timed out',
];

/**
 * Maps dashboard layout save errors to a user-facing message.
 * Returns null when auth interceptor already handled the session.
 */
export const getDashboardLayoutSaveErrorMessage = (error: unknown): string | null => {
  if (!(error instanceof Error)) {
    return 'Could not save dashboard. Please try again.';
  }

  const normalizedMessage = error.message.trim().toLowerCase();

  if (normalizedMessage === 'authentication required') {
    return null;
  }

  if (NETWORK_ERROR_PATTERNS.some((pattern) => normalizedMessage.includes(pattern))) {
    return 'Could not save dashboard. Check your connection and try again.';
  }

  if (normalizedMessage.includes('invalid input data')) {
    return 'Could not save dashboard. The layout is invalid.';
  }

  return error.message || 'Could not save dashboard. Please try again.';
};
